import React, { createContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { config } from '../../config';


export const PixelContext = createContext();

export const PixelProvider = ({ children }) => {
    const apiUrl = config.apiUrl;
    const imageUrl = config.imageUrl;
    const { slug } = useParams();
    
    // সমস্ত স্টেট
    const [pixel, setPixel] = useState({});
    
    // সমস্ত ডেটা ফেচ করার ফাংশন
    const fetchPixelData = useCallback(async () => {
        try {
        const response = await axios.get(`${apiUrl}/pixels`);
        setPixel(response.data.pixels[0]);
        } catch (error) {
        console.error("Error fetching pixel data:", error);
        }
    }, [apiUrl]);
    
    // প্রাথমিক ডেটা লোড
    useEffect(() => {
        fetchPixelData();
    }, [fetchPixelData]);
    
    return (
        <PixelContext.Provider value={{ pixel }}>
        {children}
        </PixelContext.Provider>
    );
}
